import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import whatsAppIcon from '../../images/icons/whatsappIcon.jpg';


const WhatsAppIcon = () => {
  const { selectedListing } = useSelector(state => state.filterSearch);
  return (
    <Fragment>
      <a href="#" target="_blank">
        <img onClick={() => {
          typeof(selectedListing.title) === "undefined" ?
          window.location.href = `https://wa.me/2347070019934?text=${`Service required LifeCare Front`}` :
          window.location.href = `https://wa.me/2347070019934?text=${
          `Hello LifeCare Front, my last check:
           listing No: ${selectedListing.productRef}, Property-Type: ${selectedListing.title}, 
           Property-Location: ${selectedListing.areaName}, ${selectedListing.city}, ${selectedListing.state}`}`      
        }} className='whatsapp-img' src={whatsAppIcon}/>

      </a>
    </Fragment>
  );
};


export default WhatsAppIcon;
